import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import SwitchWithLabel from "../../common/CustomSwitch";
import { RadioGroupWithLabel } from "../../common/RadioGroup";
import ExcessiveLength from "../../common/ExcessiveLength";
import appConstants from "../../../../../../../appConstants";
import { getExcessiveShipmentList } from "../util";
import MESSAGES from "../../../../../../../appMessages";
import { inject, observer } from "mobx-react";
import { getCustomLabel } from "../../../utils";

const ShipmentDetails = ({
  classes,
  priorityShipmentsList,
  editInfo,
  errorInfo,
  routeData,
  handleChange,
  DispatchStore,
  configJSON
}) => {
  const expediteLabel = getCustomLabel(appConstants.CUSTOM_LABELS.GUARANTEED_SHIPMENT, DispatchStore.staticClientData)
  const enableExcessiveLengthOption = configJSON?.enableExcessiveLengthOption;
  const enableFreezableOption = configJSON?.enableFreezableOption;
  const enableInbondOption = configJSON?.enableInbondOption;
  return (
    <div id="shipmentDetails">
      <Typography variant="subtitle1" className={classes.headerLabel}>
        SHIPMENT DETAILS
      </Typography>
      <RadioGroupWithLabel
        rowLabel={`${expediteLabel} Shipment`}
        onChange={handleChange("priority")}
        options={priorityShipmentsList}
        value={editInfo.priority}
      />
      <SwitchWithLabel
        rowLabel="Food"
        onChange={handleChange("isFood")}
        value={editInfo.isFood}
      />
      {enableExcessiveLengthOption && (
        <ExcessiveLength
          rowLabel={"Excessive Length"}
          data={{
            isExcessiveLength: editInfo.isExcessiveLength,
            excessiveLengthValue: {
              feet: editInfo.excessiveProLength,
              inches: editInfo.excessiveLengthInches
            }
          }}
          excessiveLengthError={errorInfo.excessiveProLength}
          handleExcessiveLengthFeetChange={handleChange('excessiveProLength')}
          handleExcessiveLengthInchesChange={handleChange('excessiveLengthInches')}
          handleIsExcessiveLengthChange={handleChange('isExcessiveLength')}
          maxAllowedTrailerLength={routeData.trailer.length}
          rowDescription={MESSAGES.PROCESS_PICKUP_OR_DELIVERY.EXCESSIVE_LENGTH_DESCRIPTION}
          collapseOpen={editInfo.isExcessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES}
          options={getExcessiveShipmentList()}
        />
      )}
      {enableFreezableOption && (
        <SwitchWithLabel
          rowLabel="Freezable"
          onChange={handleChange("isFreezable")}
          value={editInfo.isFreezable}
        />
      )}
      {enableInbondOption && (
        <SwitchWithLabel
          rowLabel="Inbond"
          onChange={handleChange("isInbond")}
          value={editInfo.isInbond}
        />
      )}
      {/* <SwitchWithLabel
        rowLabel="Ammunition"
        onChange={handleChange("isAmmunition")}
        value={editInfo.isAmmunition}
      /> */}
    </div>
  );
};

export default inject('DispatchStore')(observer(withStyles(styles)(ShipmentDetails)));
